module.exports = __webpack_public_path__ + "img/06-0使命.22fc2282.svg";